import { formatDate } from "./format-date";

type AdministrativeDocumentLike = {
  name?: string | null;
  number?: string | null;
  issueDate?: string | null;
};

export function formatAdministrativeDocument(
  doc?: AdministrativeDocumentLike | null,
): string | undefined {
  if (!doc) return undefined;

  const name = doc.name?.trim();
  const number = doc.number?.trim();
  const date = doc.issueDate ? formatDate(doc.issueDate) : undefined;

  const parts: string[] = [];
  if (name) parts.push(name);
  if (number) parts.push(`№ ${number}`);
  if (date) parts.push(`от ${date}`);

  return parts.length ? parts.join(" ") : undefined;
}


